import React, {useMemo, useState} from 'react';
import CustomModal from "../../../components/UI/CustomModal";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {useDispatch, useSelector} from "react-redux";
import {Drawer, Checkbox} from "antd";
import {Btn, ErrorText, FlexColumnSection, FlexRowSection, SmallHeader} from "../../../styles/globalStyles";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {t} from "i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {DB_TIME_FORMAT} from "@arboxappv4/shared/src/constants/constants";
import dayjs from "dayjs";
import {COURSE_PARTIAL_DAYS_MODAL, updateModalRes} from "@arboxappv4/shared/src/redux/modalManagerSlice";

const CoursePartialBookingDaysSelect = (props) => {
    const { isOpen, onClose, course, partialMembership} = props;
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const [showError, setShowError] = useState(false);
    const [selectedDays, setSelectedDays] = useState([])

    const {isMobile} = useScreenSize();
    const dispatch = useDispatch()

    const options = useMemo(() => course.series_events?.map(day => {
        const isOpen = course.openDays.some(op => op.id === day.id)
        return ({
            ...day,
            value: day.id,
            label: `${t(`partial-day-checkbox-${isOpen ? 'open' : 'full'}`, {
                day: t(`day-${day.day_of_week}`),
                start: dayjs(day.start, DB_TIME_FORMAT).format(globalLocation.time_format),
                end: dayjs(day.end, DB_TIME_FORMAT).format(globalLocation.time_format),
                interpolation: {'escapeValue': false}
            })}${day.description ? ` - ${day.description}` : ''}`,
            disabled: !isOpen
        })
    }, [course]));
    const isValid = useMemo(() => selectedDays.length === partialMembership.numOfDays, [selectedDays]);

    const submit = () => {
        if(isValid) {
            setShowError(false)
            dispatch(updateModalRes({modalName: COURSE_PARTIAL_DAYS_MODAL, res: selectedDays}))
            onClose()
        } else {
            setShowError(true)
        }
    }

    const getDaysSelectComp = () => {
        return (
            <FlexColumnSection gap={'20px'}>
                <FlexRowSection justify={'space-between'}>
                    <SmallHeader fontSize={'18px'}>{t('hug-partial-days-select-header')}</SmallHeader>
                    {isMobile && <div onClick={onClose}><FontAwesomeIcon icon={light('x')} color={Colors.siteBlack} size={'xs'}/></div>}
                </FlexRowSection>
                <FlexColumnSection gap={'10px'}>
                    <FlexColumnSection gap={'10px'}>
                        <Checkbox.Group options={options} onChange={setSelectedDays} style={{flexDirection: 'column', gap: '5px'}}/>
                    </FlexColumnSection>
                    {showError && <ErrorText>{t(`select-hug-partial-day${partialMembership.numOfDays === 1 ? '' : 's'}-error`, {num: t(`${partialMembership.numOfDays}-days`)})}</ErrorText>}
                </FlexColumnSection>
                <FlexRowSection gap={'10px'} justify={'end'}>
                    <Btn onClick={onClose}>{t('close')}</Btn>
                    <Btn type={'primary'} onClick={submit}>{t('proceed')}</Btn>
                </FlexRowSection>
            </FlexColumnSection>
        )
    }

    return (
        <>
            {
                isMobile ?
                    <Drawer classNames={{body: 'select-date-mobile-drawer-body'}}
                            placement={'bottom'}
                            closable={false}
                            onClose={onClose}
                            open={isOpen}
                            style={{borderTopLeftRadius: 20, borderTopRightRadius: 20}}
                    >
                        {getDaysSelectComp()}
                    </Drawer>
                    :
                    <CustomModal open={isOpen} onCancel={onClose} width={'500px'}>
                        {getDaysSelectComp()}
                    </CustomModal>
            }
        </>
    );
};

export default CoursePartialBookingDaysSelect;